import React, { useState } from "react";
import "../styles/Footer.css";
import logo from "../assets/logo-black.png"; // Company logo
import facebookIcon from "../assets/facebook-logo.png";
import instagramIcon from "../assets/instagram-logo.png";
import linkedinIcon from "../assets/linkedin-logo.png";
import { Link, useNavigate } from "react-router-dom";

const Footer = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  const handleNewsletterSubmit = () => {
    //fetch('http://localhost:5000/subscribe-newsletter', {
      // Replace with your backend URL if deployed
      fetch('https://growth-lab-backend.onrender.com/subscribe-newsletter', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email }),
    })
      .then((response) => {
        if (response.ok) {
          setMessage('Successfully subscribed to the newsletter!');
          setEmail(''); // Clear the input field
        } else {
          setMessage('Failed to subscribe. Please try again.');
        }
      })
      .catch((error) => {
        console.error('Error:', error);
        setMessage('An error occurred. Please try again.');
      });
  };

  const handleLogoClick = () => {
    navigate('/'); // Navigate to the home page
    setTimeout(() => {
      const headerElement = document.getElementById('header-section');
      if (headerElement) {
        headerElement.scrollIntoView({ behavior: 'smooth' });
      }
    }, 0);
  };
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Left: Logo and Social Media */}
        <div className="footer-left">
          <img src={logo} alt="Growth Lab Logo" className="footer-logo" onClick={handleLogoClick} style={{ cursor: 'pointer' }}/>
          <div className="footer-social">
            <a
              href="https://www.facebook.com/profile.php?id=61579455182563"
              rel="noreferrer"
              target="_blank"
            >
              <img src={facebookIcon} alt="Facebook" />
            </a>
            <a
              href="https://www.instagram.com/growthlabadvertising/"
              rel="noreferrer"
              target="_blank"
            >
              <img src={instagramIcon} alt="Instagram" />
            </a>
            <a
              href="https://www.linkedin.com/company/growth-lab-advertising/"
              rel="noreferrer"
              target="_blank"
            >
              <img src={linkedinIcon} alt="LinkedIn" />
            </a>
          </div>
        </div>

        {/* Right: Newsletter Input */}
        <div className="footer-newsletter">
          <p>Enter Your Email Below to Get Our Newsletter!</p>
          <div className="footer-input">
            <input
              type="email"
              placeholder="e.g., 'john@email.com'"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              aria-label="Newsletter Email Input"
            />
            <button type="submit" onClick={handleNewsletterSubmit} aria-label="Submit Newsletter">
              &rarr;
            </button>
          </div>
          {message && <p className="newsletter-message">{message}</p>}
        </div>

        {/* Privacy Policy & Terms */}
        <div className="footer-links">
          <Link to="/meet-the-team" className="footer-link">
            Meet the Team
          </Link>
          <Link to="/privacy-policy" className="footer-link">
            Privacy Policy
          </Link>
          <Link to="/terms-and-conditions" className="footer-link">
            Terms & Conditions
          </Link>
        </div>
      </div>

      {/* Bottom: Copyright */}
      <div className="footer-copyright">
        <p>© 2026 Growth Labs LLC. All Rights Reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
